import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ css }) => {
  return {
    container: css`
      max-width: 600px;
    `
  }
})
